import imagesJson from '@designwithfriends/common/images/images.json';

/** Where artwork for notifications and credit grants must live: the assets bucket, at its current or its legacy address. */
export const ASSETS_BASE_URL = imagesJson.assetsBaseUrl;

const isAssetUrl = (url) =>
    url.startsWith(`${imagesJson.assetsBaseUrl}/`) || url.startsWith(`${imagesJson.legacyAssetsBaseUrl}/`);

/**
 * Returns a user-facing error string when `raw` is set but invalid, or null
 * when it's empty or a well-formed asset URL. Centralized so the notifications
 * composer and grant-credits composer agree on what counts as a valid URL.
 */
export function validateImageUrl(raw) {
    const url = (raw ?? '').trim();
    if (!url) return null;
    try {
        new URL(url);
    } catch {
        return 'Invalid URL.';
    }
    return isAssetUrl(url) ? null : `Only ${ASSETS_BASE_URL}/… URLs are supported.`;
}
